<div class="betslip-over-ask-review-content">
    <div class="betslip-over-ask-review-content-header">
        <span class="betslip-over-ask-review-badge">{{ messages.badgeTitle }}</span>
        <p class="betslip-over-ask-review-message" [innerHtml]="messages.limitWarning"></p>
        <bs-over-ask-accept-timeout [seconds]="remainingSeconds" [messages]="messages" />
    </div>
    <bs-digital-over-ask-pick-list
        class="betslip-over-ask-pick-list-component"
        [props]="pickListProps"
        [overAskFlowState]="overAskFlowState"
        [oddsDisplayFormat]="oddsDisplayFormat" />
</div>
<bs-digital-over-ask-summary [props]="summaryProps" [oddsDisplayFormat]="oddsDisplayFormat" />
